import styled from 'styled-components'
import AppBar from 'material-ui/AppBar'
import images from '../../config/images'

export const Header = styled(AppBar)`
  background: linear-gradient(279.27deg, #29A5F6 -235.04%, #4589F1 -116.41%, #4688F1 -113.4%),
  linear-gradient(91.6deg, #563FFB -31.42%, #26A9EF 13.73%, #83EFD3 68.54%);
  opacity: 1.00;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.24), 0px 0px 4px rgba(0, 0, 0, 0.12);
`

export const GuestBackground = styled.div`
  background-image: url(${images.guestmodeBackground});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`

export const Mask1 = styled.div`
  background: rgba(88, 148, 243, 0.296196);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  filter: blur(13.5914px);
`

export const Background = styled.div`
  background: #F6F9FC;
`

export const menuItemStyles = {
  marginBottom: '0.5rem',
  color: '#6B7C93',
  fontSize: '14px'
}

export const guestMenuItemStyles = {
  marginBottom: '0.5rem',
  color: '#FFFFFF',
  fontSize: '14px'
}

export const trialPeriodDialogStyle = {
  backgroundColor: '#fff',
  border: '1px solid #fff',
  padding: '10px'
}

export const giftIconStyle = {
  display: 'block',
  margin: '0 auto'
}

export const trialPeriodDialogTitleStyle = {
  color: '#6b7d95',
  textAlign: 'center'
}

export const trialDialogDescriptionStyle = {
  color: "#fb332e",
  padding: "5px",
  backgroundColor: "#e6ebf0"
}



// WEBPACK FOOTER //
// src/layouts/LoggedIn/styles.js